// extracted by mini-css-extract-plugin
export default {"error":"Error404_error__CImOl","error404":"Error404_error404__P5+a9","errorTitle":"Error404_errorTitle__gASla"};